import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// KTK-224 — Channel subscription editor for the Agent V2 settings drawer.
//
// Each toggle fires onToggle(channelId, subscribed) which the consumer
// wires to hub.subscribeAgent / unsubscribeAgent. Hub is expected to
// fan an `agent_set_channels` frame to the runtime so the worker
// updates its in-memory subscription set on the next turn.
//
// The agent's DM channel is locked (always subscribed) — it's the
// 1-on-1 surface the chat UI is rendering, so unsubscribing would
// silently break the chat.
import { useState } from "react";
import { Icon } from "./icons.js";
export function ChannelSubscriptionsEditor({ channels, subscribedIds, dmChannelId = null, onToggle, }) {
    const [pendingId, setPendingId] = useState(null);
    const [error, setError] = useState(null);
    const handleToggle = async (id, next) => {
        if (pendingId)
            return;
        setPendingId(id);
        setError(null);
        try {
            await onToggle(id, next);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
        finally {
            setPendingId(null);
        }
    };
    return (_jsxs("div", { className: "card", children: [_jsxs("div", { className: "card__head", children: [_jsx("span", { className: "card__title", children: "Subscriptions" }), _jsx("span", { className: "card__sub", children: "Toggling applies on the next turn." })] }), error && (_jsx("div", { style: {
                    fontSize: "var(--fs-meta)",
                    color: "var(--accent-ink)",
                    background: "var(--accent-soft)",
                    padding: "6px 8px",
                    borderRadius: "var(--radius-sm)",
                }, children: error })), channels.length === 0 ? (_jsx("div", { className: "hint", children: "No channels in this workspace yet." })) : (_jsx("ul", { className: "chlist", children: channels.map((channel) => {
                    const isDm = channel.id === dmChannelId;
                    const checked = isDm || subscribedIds.has(channel.id);
                    const busy = pendingId === channel.id;
                    return (_jsx("li", { className: "chlist__row", style: busy ? { opacity: 0.6 } : undefined, children: _jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: checked, disabled: isDm || busy, onChange: (e) => void handleToggle(channel.id, e.target.checked) }), _jsx("span", { className: "chlist__hash", children: _jsx(Icon.hash, {}) }), _jsx("span", { className: "chlist__name", children: channel.name }), isDm && (_jsxs("span", { className: "chlist__pill", children: [_jsx(Icon.lock, {}), " DM \u00B7 locked"] })), channel.description && (_jsx("span", { className: "chlist__desc", children: channel.description }))] }) }, channel.id));
                }) }))] }));
}
//# sourceMappingURL=ChannelSubscriptionsEditor.js.map